export default __webpack_public_path__ + "static/media/Halloumi Bagel - proportioned_170.9a18ef8e.jpg";